const PRE = 'a'
export default {
    tooltip: PRE + 'Tooltip',
    popover: PRE + 'Popover',
    button: PRE + 'Button',
    icon: PRE + 'Icon',
    slider: PRE + 'Slider',
    rate: PRE + 'Rate',
    upload: 'fcUpload',
    cascader: PRE + 'Cascader',
    timePicker: PRE + 'TimePicker',
    datePicker: PRE + 'DatePicker',
    rangePicker: PRE + 'RangePicker',
    weekPicker: PRE + 'WeekPicker',
    monthPicker: PRE + 'MonthPicker',
    switch: PRE + 'Switch',
    select: PRE + 'Select',
    checkbox: PRE + 'CheckboxGroup',
    radio: PRE + 'RadioGroup',
    inputNumber: PRE + 'InputNumber',
    search: PRE + 'InputSearch',
    textarea: PRE + 'Textarea',
    formItem: PRE + 'FormModelItem',
    page: 'div',
    form: PRE + 'FormModel',
    frame: 'fcFrame',
    col: PRE + 'Col',
    row: PRE + 'Row',
    tree: PRE + 'Tree',
    autoComplete: PRE + 'AutoComplete',
    group: 'fcGroup',
    subForm: 'fcSubForm',
    object: 'fcSubForm'
}
